import React from "react";
import * as TypeStyles from "../../../../../../common-deprecated/styles/v2/lexus/globals/Type";
import useETADeliveryLabel from "../../../hooks/shared/useETADeliveryLabel";

type ETAPropsType = {
    date?: string | false;
};

const ETADeliveryLabel = ({ date }: ETAPropsType): JSX.Element | null => {
    const label = useETADeliveryLabel(date);
    if (!label) return null;

    return <TypeStyles.Text headingType="micro">{label}</TypeStyles.Text>;
};

export default ETADeliveryLabel;
